<template>
    <div>
        <div class="row m-0" style="width:100%;" id="login-user">
            <div class="p-0 col-lg-5">
                <div class="d-none d-lg-block" style="height:100%;">
                    <div class="row" id="left-div">
                        <div class="col-md-6" id="cover-img"></div>
                        <div class="p-5 cover-info col-md-6">
                            <div>
                                <h1 class="mb-5">BECOME A WILDLIFE HERO</h1>
                                <h2 class="mb-4">
                                    JOIN THE WILDLIFE PROTECTOR PRIVATE
                                    COMMUNITY
                                </h2>
                                <p>
                                    Become a wildlife Hero by sponsoring
                                    equipment and tools to the team on the
                                    ground so you can protect the endangered
                                    tigers and safeguard their homes!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-lg-none">
                    <div class="cover-info text-center mt-5 d-block d-lg-none">
                        <h1 class="mb-5 mt-5 p-1">BECOME A WILDLIFE HERO</h1>
                    </div>
                </div>
            </div>
            <div class="col-lg-7 p-0" id="create-form">
                <header class="site-header">
                    <div class="container-fluid">
                        <nav
                            class="navbar navbar-expand-lg navbar-light navbar-offcanvas py-0"
                        >
                            <a class="navbar-brand" href="/">
                                <img
                                    class="navbar-logo"
                                    src="/images/WWF_Logo.jpg"
                                />
                            </a>
                        </nav>
                    </div>
                </header>
                <div class="row p-0 m-0">
                    <div class="col-12 p-4" id="select-package">
                        <div class="row">
                            <div class="col-md-12 p-0">
                                <div class="card-body p-3">
                                    <h1 class="text-center mb-4 header-title">
                                        LOGIN TO YOUR ACCOUNT
                                    </h1>
                                    <form @submit.prevent="loginAccount">
                                        <div class="form-group row">
                                            <div class="col-md-12">
                                                <input
                                                    id="email"
                                                    type="email"
                                                    class="form-control"
                                                    name="email"
                                                    v-bind:class="{
                                                        'is-invalid':
                                                            errors.email
                                                    }"
                                                    value
                                                    required
                                                    autofocus
                                                    placeholder="E-mail Address"
                                                    v-model="fields.email"
                                                />
                                                <span
                                                    class="invalid-feedback"
                                                    role="alert"
                                                    v-if="errors.email"
                                                >
                                                    <strong>{{
                                                        errors.email
                                                    }}</strong>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-md-12">
                                                <input
                                                    id="password"
                                                    type="password"
                                                    class="form-control"
                                                    name="password"
                                                    v-bind:class="{
                                                        'is-invalid':
                                                            errors.password
                                                    }"
                                                    required
                                                    placeholder="Password"
                                                    v-model="fields.password"
                                                />
                                                <span
                                                    class="invalid-feedback"
                                                    role="alert"
                                                    v-if="errors.password"
                                                >
                                                    <strong>{{
                                                        errors.password
                                                    }}</strong>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group row mb-0 mt-3">
                                            <div class="col-md-12">
                                                <button
                                                    type="submit"
                                                    class="btn btn-primary form-control"
                                                >
                                                    Login
                                                </button>
                                            </div>
                                            <div class="col-md-12 text-center">
                                                <a
                                                    class="btn btn-link text-center mt-3"
                                                    href="/password/reset"
                                                    >Forgot Your Password?</a
                                                >
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 p-0 d-lg-none">
                <div class="cover-info text-center mt-5 d-block d-lg-none">
                    <h2 class="mb-1 p-1">
                        JOIN THE WILDLIFE PROTECTOR PRIVATE COMMUNITY
                    </h2>
                    <p class="mb-2 p-5">
                        Become a Wildlife Hero by sponsoring equipment and tools
                        to the team on the ground so you can protect the
                        endangered wildlife and safeguard their homes!
                    </p>
                    <div id="cover-img" style="height:80vh; width:100%;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["token"],
    data() {
        return {
            fields: {
                email: "",
                password: "",
                _token: this.token
            },
            errors: {
                email: "",
                password: ""
            }
        };
    },
    created() {},
    methods: {
        loginAccount() {
            fetch("/login", {
                method: "post",
                body: JSON.stringify(this.fields),
                headers: {
                    "content-type": "application/json",
                    Accept: "application/json"
                }
            })
                .then(res => {
                    if (res.status == 200) {
                        window.location.reload();
                    } else {
                        return res.json();
                    }
                })
                .then(data => {
                    if (typeof data != "undefined") {
                        if (typeof data.errors != "undefined") {
                            this.errors.email =
                                typeof data.errors.email != "undefined"
                                    ? data.errors.email[0]
                                    : "";
                            this.errors.password =
                                typeof data.errors.password != "undefined"
                                    ? data.errors.password[0]
                                    : "";
                        }
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>
<style scoped>
#login-user {
    min-height: 90vh;
}
.btn-primary {
    background-color: #f07d00;
    border-color: #f07d00;
}
@media only screen and (max-width: 575px) {
    #login-user {
        min-height: 30vh;
    }
    #login-user .form {
        min-height: 30vh;
    }
}
@media only screen and (max-width: 768px) {
    .header-title[data-v-06688fcd] {
        font-size: 2rem;
        margin-top: 1rem !important;
    }
    .btn-primary:not(:disabled):not(.disabled):active,
    .btn-primary:not(:disabled):not(.disabled).active,
    .show > .btn-primary.dropdown-toggle {
        background-color: #d06d01;
        border-color: #d06d01;
    }
}

/* ////////////// */

#cover-img {
    background-image: url("/images/pages/checkout/Vertical-Join-Wildlife-Observer.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 100%;
    height: auto;
}
.card-body {
    margin-bottom: 0px;
}
.card-body h1 {
    font-family: "WWF";
    font-size: 3rem;
    text-align: center;
    line-height: 1;
    padding-bottom: 10px;
}
.payment-frequency {
    border-radius: 50%;
    border: 4px solid white;
    height: 110px;
    width: 110px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
}
.payment-frequency.text-center {
    font-size: 0.8rem;
    font-weight: 400;
}
.payment-frequency.text-center:hover {
    cursor: pointer;
}
.payment-frequency-section .col-4 {
    padding: 0;
}
.payment-frequency-section .col-4 p {
    margin: 0;
}
.stripe-card {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem;
    height: calc(1.6em + 0.75rem + 2px);
}
.payment-frequency-section .active {
    border-color: #ffffff;
    background-color: #f58220;
    color: white;
}

.cover-info {
    display: flex;
    justify-content: center;
    align-items: center;
}
.cover-info h1 {
    color: #ffca00;
    font-size: 3rem;
    margin-bottom: 1.5rem !important;
}
.cover-info h2 {
    color: white;
    font-size: 2rem;
}
.cover-info p {
    color: white;
    font-size: 1rem;
}
.cover-info h1,
.cover-info h2 {
    font-family: "WWF";
    line-height: 1;
}
#left-div {
    padding: 0;
    background-color: black;
    min-height: 100%;
    position: relative;
}
#left-div .col-6 {
    padding: 0;
}
#select-package {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 30vh;
}
#select-package #subscription {
    margin-top: 20px;
    margin-bottom: 50px;
}
#select-package ul {
    list-style: none;
}
#select-package ul li {
    margin-top: 10px;
    font-weight: normal;
    font-size: 0.9rem;
}
#select-package .col-12 {
    background-color: #f58220;
    font-size: 2em;
    color: white;
    padding-bottom: 6px;
}
#select-package #bah-btn:hover {
    cursor: pointer;
}
@media only screen and (max-width: 992px) {
    .cover-info h2,
    .cover-info p {
        color: black;
    }
    #select-package ul li {
        font-size: 0.7rem;
        font-weight: normal;
    }
    #adopt .p-5 {
        padding: 2.4rem !important;
    }

    header {
        display: none;
    }
}
.card-body button {
    font-size: 1.2em;
}
@media only screen and (min-width: 992px) {
    #select-package {
        min-height: 60vh;
    }
}
</style>
